<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                © Copyright {{year}}. MAGIIS. All rights reserved - v2.00.0
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    <!-- Design & Develop by Themesbrand -->
                </div>
            </div>
        </div>
    </div>
</footer>